/*
 * Copyright (c) 2021 CalAmp Corp.  All Rights Reserved
 */

// eslint-disable-next-line no-barrel-files/no-barrel-files
export * from '../layout/types';

/**
 * Defines the iOn Suite Application keys which are to be used for all iOn specific
 * constant references, such as when initializing User Preferences, getting / setting
 * localStorage values, etc.
 */
export enum ApplicationKeys {
  iOnSuite = 'ion-suite',
  iOnSuiteSession = 'ion-suite-session',
  iOnSuitePage = 'ion-suite-page',
  CTCAdmin = 'ion-ctc-admin',
  CTCAdminSession = 'ion-ctc-admin-session',
  CTCAdminPage = 'ion-ctc-admin-page'
};

// defines the ctc role names ...
export enum SuperAdminRole {
  SuperAdmin = 'Super Admin'
}
